import styled from 'styled-components';
const SymbolBox = styled.span `
  border: 2px solid rgba(0, 0, 0, 0.15);
  width: 65px;
  height: 65px;
  display: flex;
  justify-content: center;
  border-radius: 7%;
  margin-right: 16px;
  vertical-align: middle;
  line-height: 65px;
`;
export default SymbolBox;
